import { apis } from '../apiBase/apiBase';
export const crossSearchApis = apis.injectEndpoints({
    endpoints: (builder) => ({
        getRecordsCount: builder.query({
            query: (params) => {
                return {
                    url: `cross-search/records-count`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        // エンティティ横断検索API
        searchEntitiesByEntity: builder.query({
            query: (params) => {
                return {
                    url: `cross-search/search-entities-by-entity`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
    }),
    overrideExisting: false,
});
export const { useGetRecordsCountQuery, useLazyGetRecordsCountQuery, useSearchEntitiesByEntityQuery, useLazySearchEntitiesByEntityQuery, } = crossSearchApis;
